import { TRACKING_URL_PARAMS } from '../url-keys'
import { urlParamsWithNamespace, urlWithParams } from '../../helpers/url-params.js'

const List = {
  init: function({filter, eventCreationAllowed, includeSearchField, siteOrigin, containerId}) {
    const wrapperElement = document.getElementById(containerId)
    const newIframeElement = document.createElement('iframe')

    let url = `${siteOrigin}/local/embed_list_only`

    if (filter) {
      const searchParams = urlParamsWithNamespace(filter, 'filter')
      url = urlWithParams(url, searchParams)
    }

    if (eventCreationAllowed !== undefined) {
      url = urlWithParams(url, {event_creation_allowed: eventCreationAllowed})
    }

    if (includeSearchField !== undefined) {
      url = urlWithParams(url, {include_search_field: includeSearchField})
    }

    const currentWindowParams = new URLSearchParams(window.location.search)
    const trackingUrlParamsToInclude = {}
    TRACKING_URL_PARAMS.forEach(key => {
      if (currentWindowParams.get(key)) {
        trackingUrlParamsToInclude[key] = currentWindowParams.get(key)
      }
    })

    newIframeElement.src = urlWithParams(url, trackingUrlParamsToInclude)

    newIframeElement.style = 'width: 100%; height: 100%; border: none;'
    wrapperElement.appendChild(newIframeElement)
  }
}

if (window.ControlShift && window.ControlShift.List && window.ControlShift.List.options) {
  List.init(window.ControlShift.List.options)
} else {
  console.warn('ControlShift.List.options script is not properly defined in your page.')
}

